import { render, staticRenderFns } from "./UserAccountActions.vue?vue&type=template&id=0efd7aa3&lang=pug&"
import script from "./UserAccountActions.vue?vue&type=script&lang=js&"
export * from "./UserAccountActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports